module.exports = __webpack_public_path__ + "static/gallery-8@2x-92b5750cb15cabf16e6ee8ef3cb6cc95.jpg";